import styled from 'styled-components';

import {MiniLoadingView} from '@/components/static/mini-loading-view';
import {usePatientGroups} from '@/hooks/backend/use-patient-groups';
import {PatientTransformed} from '@/model/transformers/transform-patient';

type PatientGroupsProps = {
    patient: PatientTransformed;
};

const PatientGroups = ({patient}: PatientGroupsProps) => {
    const [groupsLoading, groups] = usePatientGroups({
        patientId: patient.patientId?.id ?? '',
    });

    if (groupsLoading) {
        return (
            <StyledWrapper>
                <MiniLoadingView />
            </StyledWrapper>
        );
    }

    return (
        <StyledWrapper>
            <ul className="groups-info">
                {groups?.map(g => (
                    <li key={g.groupId?.id ?? g.name}>{g.name}</li>
                ))}
            </ul>
        </StyledWrapper>
    );
};

//language=SCSS
const StyledWrapper = styled.div`
& {
    .groups-info {
        padding-bottom: 0;
        margin-bottom: 0;
    }
}
`;

export {PatientGroups};
